import {all, call, put, takeEvery} from "redux-saga/effects";
import {
  WidgetsActionTypes,
  deleteError,
  deleteSuccess,
  fetchError,
  fetchSuccess,
  fetchItemSuccess,
  fetchItemError,
  createError,
  createSuccess,
  updateSuccess,
  updateError,
  updateOrderSuccess,
  updateOrderError
} from "@actions/widget";
import widgetApi from "@api/widget";
import {ReduxAction} from "@actions/index";


const snakeToCamel = str => {
  return str.replace(/([-_][a-z])/g, group =>
    group
      .toLowerCase()
      .replace("-", "")
      .replace("_", "-")
  );
};


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(widgetApi.getList, payload);
    yield put(fetchSuccess(res));
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(widgetApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err));
  }
}

/**
 * There should be a type in payload to handle proper request
 * @param payload
 */
function* handleCreate({payload}: ReduxAction) {
  try {
    const widgetType = payload.payload.type;
    const response = yield call(
      widgetApi.create,
      payload,
      snakeToCamel(widgetType)
    );
    const widget = response.data;
    yield put(createSuccess(widget));
    payload.onSuccessCallback && payload.onSuccessCallback(widget);
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

/**
 * There should be a type in payload to handle proper request
 * @param payload
 */
function* handleUpdate({payload}: ReduxAction) {
  try {
    const widgetType = payload.payload.type;
    const response = yield call(
      widgetApi.update,
      payload,
      snakeToCamel(widgetType)
    );
    
    const widget = response.data;
    yield put(updateSuccess(widget));
    payload.onSuccessCallback && payload.onSuccessCallback();
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const widgetType = payload.type;
    const res = yield call(widgetApi.getItem, payload, snakeToCamel(widgetType));
    yield put(fetchItemSuccess(res.data));
  } catch (err) {
    yield put(fetchItemError(err));
  }
}

function* handleUpdateOrder({payload}: ReduxAction) {
  const items = {payload: {items: payload.payload.items}}
  try {
    yield call(widgetApi.updateOrder, items);
    yield put(updateOrderSuccess(payload.payload.orderedItems));
  } catch (err) {
    yield put(updateOrderError(err));
  }
}


function* widgetsSaga() {
  yield all([
    yield takeEvery(WidgetsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(WidgetsActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(WidgetsActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(WidgetsActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(WidgetsActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
    yield takeEvery(WidgetsActionTypes.UPDATE_ORDER_REQUEST, handleUpdateOrder)
  ]);
}

export default widgetsSaga;
